import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  isDevMode,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';

import { MessageService } from 'primeng/api';
// import { authInterceptor } from './interceptors/auth.interceptor';
// import { ErrorService } from './shared/services';
// import { HttpErrorInterceptor } from './interceptors/http-error-hanlder.interceptor';
import { providePrimeNG } from 'primeng/config';
import MyPreset from '../theme/app-theme';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { TokenRefreshInterceptor } from './interceptors/token-refresh.interceptor';
import { AuthService } from './modules/auth/services/auth.service';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(BrowserAnimationsModule),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideTransloco({
      config: {
        availableLangs: ['pl', 'en'],
        // Admin startuje po polsku (decyzja 2026-10-16: PL domyślnie wszędzie); zapamiętany
        // wybór stosuje LanguageService (bez wykrywania języka przeglądarki).
        defaultLang: 'pl',
        fallbackLang: 'pl',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    }),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: '.app-dark' // Klasa CSS do przełączania trybu
        }
      },
    }),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenRefreshInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    MessageService,
    // Uprawnienia odtworzone z localStorage mogą być nieaktualne — odśwież je w tle z
    // GET /auth/permissions (bez blokowania startu); guard tablicy odświeża je też przy wejściu.
    provideAppInitializer(() => inject(AuthService).refreshPermissionsOnStartup()),
  ],
};
